export const Text = [
    "Vue.js is a frontend JavaScript framework. We combine it with the backend system that is most suitable for your business logic to achieve your business goals. It has a two-way data binding and maintains Virtual DOM. As it adopts the MVVM architectural pattern, the core library is highly focused on the view layer and hence is a perfect fit for single page applications.",
    "We integrate our rich Vue.js frontend solutions with suitable backend technologies like NodeJS, Python, .NET & ColdFusion based upon the customer's preference & their existing infrastructure. We use MongoDB, MS-SQL, MySQL and PostgreSQL backend database for deploying our VueJS web app and API development using RESTful API & GraphQL.",
   "We built some inspiring interfaces in VueJS and if you are looking for a VueJS developers for hiring, your search ends here.",
]

export const Text1 = [
    "IStellar is one of the earlier-adopters of Vue.js and we offer dedicated VueJS development services with the most advanced tools and techniques as well as developing methods for on-time project delivery. Our team follows a specific method for satisfying the needs of our clients. We have a strong focus on UI/UX designs and provide flexible delivery models and also provide flexible engagement with the clients to meet diverse business needs. You can expect quality deliverable at an affordable rate from our company. Our excellent track record shows our uniqueness in the industry.",
    "We always make sure that our Development team always stay updated to the latest technologies, tools and updates in Vue.JS Framework. We have good experience in all VueJS ecosystem libraries such as Vue router for handling modular SPA routing, Vuex for state management & used as a centralized store for all VueJS components & SSR for Server-Side Rendering.",
    "We provide regular reporting facility to our clients on daily, weekly basis depending on the their needs and demands. We used GIT in most of our projects to easily maintain the source code versions & deployments. We develop apps using high coding standards, proper planning, research and we deliver fast, efficient tested quality work.",
   
]


export const list1=[
    {
        ul: [
            {li: "ReactJS development",
            path: "/services/reactjs-development"},
            {li: "AngularJS development",
            path: "/services/angular-development"},
            {li: "Angular development",
            path: "services/angular-development"},
            {li: "NodeJS API development",
            path: "/services/nodejs-development"},
            {li: "D3.JS Data Visualization",
            path: "/"},
            {li: "React Native Mobile App Development",
            path: "/services/reactjs-development"},
        ]
    }
]

export const list2=[
    "Health Care",
    "Real Estate",
    "E-Commerce",
    "Education",
]

export const VueServices = [
    {
        h6: "Single-Page Applications",
        para: "Vue.js has become our preferred choice of SPA development which ensures fast response time and improve performance. Empowering the complex and sophisticated one-page applications, it won't let you stuck due to performance issues."
    }, {
        h6: "Vue.js Web Application Development",
        para: "Custom app development within the designated time without compromising quality makes us one of the well-known Vue.js development company. Our developers provide end-to-end custom app development services from initial planning to final Vue.js app deployment at your servers (could be either shared hosting, dedicated or cloud) ."
    }, {
        h6: "Custom Applications Development",
        para: "Custom app development within the designated time without compromising quality makes us one of the well-known Vue.js development company. Our developers provide end-to-end custom app development services from initial planning to final Vue.js app deployment at your servers (could be either shared hosting, dedicated or cloud) ."
    }, {
        h6: "Interactive UI Development with Vue.js",
        para: "With Vue.js JavaScript Library we can build interactive UI/UX that actually scale. Build awesome interfaces which your users love. Interactivity builds customer loyalty to your product."
    }, {
        h6: "Vue.js Support & Maintenance",
        para: "We are not only provide Vue.js web app development services but also provide complete support and maintenance services to our customers. Application upgrades, performance, bug monitoring & resolutions, security updates, quick fixes & backups."
    },  
]
export const VUEJS1 = [
    "Vuejs1",
]
export const VUEJS2 = [
    "Vuejs2",
]
export const VUEJS3 = [
    "Vuejs3",
    
]